// Expressions
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(0)`. */
export const s0 = { kind: 'Identity', spacingType: 's0' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(1)`. */
export const s1 = { kind: 'Identity', spacingType: 's1' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(2)`. */
export const s2 = { kind: 'Identity', spacingType: 's2' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(3)`. */
export const s3 = { kind: 'Identity', spacingType: 's3' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(4)`. */
export const s4 = { kind: 'Identity', spacingType: 's4' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(5)`. */
export const s5 = { kind: 'Identity', spacingType: 's5' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(6)`. */
export const s6 = { kind: 'Identity', spacingType: 's6' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(7)`. */
export const s7 = { kind: 'Identity', spacingType: 's7' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(8)`. */
export const s8 = { kind: 'Identity', spacingType: 's8' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(9)`. */
export const s9 = { kind: 'Identity', spacingType: 's9' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(10)`. */
export const s10 = { kind: 'Identity', spacingType: 's10' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(11)`. */
export const s11 = { kind: 'Identity', spacingType: 's11' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(12)`. */
export const s12 = { kind: 'Identity', spacingType: 's12' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(13)`. */
export const s13 = { kind: 'Identity', spacingType: 's13' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(14)`. */
export const s14 = { kind: 'Identity', spacingType: 's14' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(15)`. */
export const s15 = { kind: 'Identity', spacingType: 's15' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(16)`. */
export const s16 = { kind: 'Identity', spacingType: 's16' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(18)`. */
export const s18 = { kind: 'Identity', spacingType: 's18' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(20)`. */
export const s20 = { kind: 'Identity', spacingType: 's20' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(21)`. */
export const s21 = { kind: 'Identity', spacingType: 's21' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(22)`. */
export const s22 = { kind: 'Identity', spacingType: 's22' };
/** @deprecated Use the MF theme spacing instead: `theme.mf.spacing(n)`. */
export const getSpacing = (spacing) => (props) => getSpacingStringFromDescription(spacing, props.theme);
/** @deprecated Use the MF theme spacing instead. */
export const negative = (spacing) => ({ kind: 'Negative', spacing });
/** @deprecated Use the MF theme spacing instead. */
export const divide = (spacing, divisor) => ({ kind: 'Divide', spacing, divisor });
// Evaluation
/** @deprecated Use the MF theme spacing instead. */
// eslint-disable-next-line consistent-return
export const calcSpacing = (spacing, theme) => {
    // eslint-disable-next-line default-case
    switch (spacing.kind) {
        case 'Identity':
            return theme.spacing.spacingMap[spacing.spacingType];
        case 'Negative':
            return -1 * calcSpacing(spacing.spacing, theme);
        case 'Divide':
            return calcSpacing(spacing.spacing, theme) / spacing.divisor;
    }
};
/** @deprecated Use the MF theme spacing instead. */
export const getSpacingStringFromDescription = (spacing, theme) => {
    // If spacing is a list
    if (spacing instanceof Array) {
        return spacing.map(sp => getSpacingStringFromDescription(sp, theme)).join(' ');
    }
    if (typeof spacing === 'string') {
        return spacing;
    }
    return `${calcSpacing(spacing, theme)}${theme.spacing.unit}`;
};
/** @deprecated Use the MF theme spacing instead. */
export const DefaultSpacingConfiguration = {
    unit: 'px',
    spacingMap: {
        s0: 0,
        s1: 4,
        s2: 8,
        s3: 12,
        s4: 16,
        s5: 20,
        s6: 24,
        s7: 28,
        s8: 32,
        s9: 36,
        s10: 40,
        s11: 44,
        s12: 48,
        s13: 52,
        s14: 56,
        s15: 60,
        s16: 64,
        s18: 72,
        s20: 80,
        s21: 84,
        s22: 88,
    },
};
